// extracted by mini-css-extract-plugin
module.exports = {"WeekdayLabel":"PlannedTourEditDialog_WeekdayLabel__1Mp_x"};